var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEventExportIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.6663H12V12.9997H0V11.6663ZM6.66667 2.88529V10.333H5.33333V2.88529L1.28595 6.93267L0.343147 5.98987L6 0.333008L11.6569 5.98987L10.7141 6.93267L6.66667 2.88529Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEventExportIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/EventExportIcon.5205c702.svg";
export { ForwardRef as ReactComponent };